export default __webpack_public_path__ + "static/media/howtouse_basic_05_02_ko.0079eaa9.png";